var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.75 27.874L30.312.602.75 19.674v10.704c0 1.04.508 2.014 1.361 2.61L39.4 59.001a3.182 3.182 0 003.605.025l26.349-17.85a3.182 3.182 0 001.397-2.634v-10.67zM3.477 22.388v7.99c0 .148.073.287.195.372L39.84 55.985v-8.489L3.477 22.388zM67.823 38.92L42.568 56.028V47.51l25.455-16.97v8.003c0 .151-.075.292-.2.377zM31.747 4.859l23.932 16.14-22.328 15.95-1.604-32.09zm26.346 17.768l8.393 5.66-11.611 7.741-7.702-5.601 10.92-7.8zm-13.26 9.47l-11.056 7.898 7.441 5.138 11.238-7.492-7.622-5.543zm-14.168 5.75l-1.128-22.559L13.49 25.987l17.175 11.86zM29.007 4.688l.372 7.428-18.305 12.202-6.035-4.167L29.007 4.69z",
    fill: "#1C1C1C"
  })));
}
export default SvgSubscriptionIcon;